/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Createlisting1Inputs */

const en_createlisting1 = /** @type {(inputs: Createlisting1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create Listing`)
};

const de_createlisting1 = /** @type {(inputs: Createlisting1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ort erstellen`)
};

/**
* | output |
* | --- |
* | "Create Listing" |
*
* @param {Createlisting1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const createlisting1 = /** @type {((inputs?: Createlisting1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Createlisting1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_createlisting1(inputs)
	return de_createlisting1(inputs)
});
export { createlisting1 as "createListing" }